import { tv } from 'tailwind-variants'

export const archivedMessageItemWrapper = tv({
  base: 'cursor-pointer transition-colors duration-300 ease-in-out px-2 py-6 hover:bg-gray-200 md:px-8'
})
